var map = {
	"./locale-provider/ar_EG.tsx": 1080,
	"./locale-provider/bg_BG.tsx": 1084,
	"./locale-provider/ca_ES.tsx": 1088,
	"./locale-provider/cs_CZ.tsx": 1092,
	"./locale-provider/de_DE.tsx": 1096,
	"./locale-provider/el_GR.tsx": 1100,
	"./locale-provider/en_GB.tsx": 1104,
	"./locale-provider/en_US.tsx": 1108,
	"./locale-provider/es_ES.tsx": 1109,
	"./locale-provider/et_EE.tsx": 1113,
	"./locale-provider/fa_IR.tsx": 1117,
	"./locale-provider/fi_FI.tsx": 1121,
	"./locale-provider/fr_BE.tsx": 1125,
	"./locale-provider/fr_FR.tsx": 1129,
	"./locale-provider/is_IS.tsx": 1133,
	"./locale-provider/it_IT.tsx": 1137,
	"./locale-provider/ja_JP.tsx": 1141,
	"./locale-provider/ko_KR.tsx": 1145,
	"./locale-provider/ku_IQ.tsx": 1149,
	"./locale-provider/nb_NO.tsx": 1153,
	"./locale-provider/nl_BE.tsx": 1157,
	"./locale-provider/nl_NL.tsx": 1161,
	"./locale-provider/pl_PL.tsx": 1165,
	"./locale-provider/pt_BR.tsx": 1169,
	"./locale-provider/pt_PT.tsx": 1173,
	"./locale-provider/ru_RU.tsx": 1177,
	"./locale-provider/sk_SK.tsx": 1181,
	"./locale-provider/sr_RS.tsx": 1185,
	"./locale-provider/sv_SE.tsx": 1189,
	"./locale-provider/th_TH.tsx": 1193,
	"./locale-provider/tr_TR.tsx": 1197,
	"./locale-provider/uk_UA.tsx": 1199,
	"./locale-provider/vi_VN.tsx": 1203,
	"./locale-provider/zh_CN.tsx": 1207,
	"./locale-provider/zh_TW.tsx": 1211
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1079;


//////////////////
// WEBPACK FOOTER
// ./components ^\.\/locale-provider\/.+_.+\.tsx$
// module id = 1079
// module chunks = 0